import welcomeTourInit from './welcome-tour-init';

export default {
  welcomeTourInit,
};
